var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/newspaper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 5C18.3334 3.61929 17.2141 2.5 15.8334 2.5L7.50004 2.5C6.11933 2.5 5.00004 3.61929 5.00004 5L4.16671 5C2.78599 5 1.66671 6.11929 1.66671 7.5V15C1.66671 16.3807 2.786 17.5 4.16671 17.5H15.8334C17.2141 17.5 18.3334 16.3807 18.3334 15L18.3334 5ZM6.52445 15.8333H15.8334C16.2936 15.8333 16.6667 15.4602 16.6667 15L16.6667 5C16.6667 4.53976 16.2936 4.16667 15.8334 4.16667L7.50004 4.16667C7.0398 4.16667 6.66671 4.53976 6.66671 5L6.66671 15C6.66671 15.2922 6.61658 15.5727 6.52445 15.8333ZM5.00004 6.66667L5.00004 15C5.00004 15.4602 4.62694 15.8333 4.16671 15.8333C3.70647 15.8333 3.33337 15.4602 3.33337 15V7.5C3.33337 7.03976 3.70647 6.66667 4.16671 6.66667H5.00004Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40002 6.66671C8.40002 6.20647 8.77312 5.83337 9.23336 5.83337H14.2334C14.6936 5.83337 15.0667 6.20647 15.0667 6.66671V10C15.0667 10.4603 14.6936 10.8334 14.2334 10.8334H9.23336C8.77312 10.8334 8.40002 10.4603 8.40002 10V6.66671ZM10.0667 7.50004V9.16671H13.4V7.50004H10.0667ZM8.40002 13.3334C8.40002 12.8731 8.77312 12.5 9.23336 12.5H14.2334C14.6936 12.5 15.0667 12.8731 15.0667 13.3334C15.0667 13.7936 14.6936 14.1667 14.2334 14.1667H9.23336C8.77312 14.1667 8.40002 13.7936 8.40002 13.3334Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.92db3126f73f4183736d62ea0c3c069f.svg";
export { ForwardRef as ReactComponent };